import { ReportResponse } from '../../../types/Report.types';
import { mapClassificationToRiskLevel } from '../../../utils/Functions.utils';

export const mapClassificationToDisplayText = (
  classification: string
): string => {
  switch (classification.toLowerCase()) {
    case 'prohibited':
    case 'prohibited_exception':
      return 'Prohibited';
    case 'high-risk':
    case 'high_risk':
      return 'High-Risk';
    case 'high_risk_exception':
      return 'High-Risk Exception';
    case 'limited-risk':
    case 'limited_risk':
    case 'limited_risk_exception':
      return 'Limited-Risk';
    case 'minimal-risk':
    case 'minimal_risk':
    case 'minimal_risk_exception':
      return 'Minimal-Risk';
    case 'excluded':
    case 'excluded_exception':
      return 'Excluded';
    case 'out_of_scope':
    case 'out-of-scope':
      return 'Out of Scope';
    default:
      return classification;
  }
};

export const buildHeaderData = (data: ReportResponse) => {
  const cor = data.classificationObligationsReport;
  const valueOrEmpty = (value?: string | null) => value ?? '';

  return {
    title: 'EU AI Act Classification & Obligations Report',
    entityType: { label: 'Entity Type', value: valueOrEmpty(cor.entityType) },
    systemName: {
      label: 'AI System Name',
      value: valueOrEmpty(cor.aiSystemName)
    },
    version: { label: 'Version', value: valueOrEmpty(cor.version) },
    organizationName: {
      label: 'Organization Name',
      value: valueOrEmpty(cor.organizationName)
    },
    provider: {
      label: 'Compliance Contact Person',
      value: valueOrEmpty(cor.complianceContactPerson)
    },
    classification: {
      risk: mapClassificationToRiskLevel(valueOrEmpty(cor.classification)),
      text: mapClassificationToDisplayText(valueOrEmpty(cor.classification))
    },
    generatedTime: valueOrEmpty(cor.generated),
    reportId: valueOrEmpty(cor.reportId)
  };
};

export const buildLegalBasisData = (data: ReportResponse) => ({
  title: 'Legal Basis',
  obligations: data.legalBasis.obligations,
  riskLevel: mapClassificationToRiskLevel(
    data.classificationObligationsReport.classification
  ) as 'limited' | 'high' | 'prohibited' | 'minimal'
});

export const buildDeclarationData = (data: ReportResponse) => ({
  title: 'Declaration',
  checkboxText: data.declaration.text,
  signedBy: data.declaration.signedBy,
  timestamp: data.classificationObligationsReport.generated
});

export const buildFooterData = (data: ReportResponse) => ({
  text: data.footerNote.text,
  email: 'compliai@skyhighgrowth.com',
  reportId: data.classificationObligationsReport.reportId,
  generatedBy: data.footerNote.generatedBy
});
